// extracted by mini-css-extract-plugin
export default {"wrap":"ea08d37bbf7d","header":"c818e89fe708","backButton":"be8cafb92a9a"};